module.exports = __webpack_public_path__ + "media/fire.4a5a950f.mp3";